// src/config.js
// Utilidad para leer variables de entorno con soporte Runtime (Docker) y Build time

const getConfig = (key) => {
  // 1. Intentar leer de window._env_ (Inyección en tiempo de ejecución por Docker)
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  // 2. Intentar leer de process.env (Inyección en tiempo de compilación)
  return process.env[key];
};

export const BACKEND_URL = getConfig('REACT_APP_BACKEND_URL');
export const HASURA_URL = getConfig('REACT_APP_HASURA_GRAPHQL_BASE_URL');
export const APP_VERSION = getConfig('REACT_APP_VERSION') || 'v1.7.10';
export const ENABLE_LOG = getConfig('REACT_APP_ENABLE_LOG') === 'true';
